import bulkInvoiceItemTypesUploads from "./bulkInvoiceItemTypesUploads.component";
import bulkInvoiceItemTypesUploadsUrls from "./bulkInvoiceItemTypesUploads.urls";
import BulkInvoiceItemTypesUploadsTransforms from "./bulkInvoiceItemTypesUploads.transforms";

const bulkInvoiceItemTypesUploadsModule = angular
  .module("app.components.bulkInvoiceItemTypesUploads", [])
  .component("bulkInvoiceItemTypesUploadsPage", bulkInvoiceItemTypesUploads)
  .service(
    "BulkInvoiceItemTypesUploadsTransforms",
    BulkInvoiceItemTypesUploadsTransforms
  )
  .config(bulkInvoiceItemTypesUploadsUrls);

export default bulkInvoiceItemTypesUploadsModule;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploads/bulkInvoiceItemTypesUploads.module.js